import { render, staticRenderFns } from "./SetupChecklist.vue?vue&type=template&id=66373267&"
import script from "./SetupChecklist.vue?vue&type=script&lang=js&"
export * from "./SetupChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66373267')) {
      api.createRecord('66373267', component.options)
    } else {
      api.reload('66373267', component.options)
    }
    module.hot.accept("./SetupChecklist.vue?vue&type=template&id=66373267&", function () {
      api.rerender('66373267', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/SetupChecklist.vue"
export default component.exports